import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { FamilyGroupLabel } from '@/api/family';

/**
 * Как называется круг клиента на его экране.
 *
 * <p>Раньше это задавалось ТИПОМ группы, который оператор выставлял руками. Тип повторял ту же ось,
 * что и круг участника (FAMILY_OFFICE ≈ FAMILY, COMPANY ≈ BUSINESS), не влиял ни на что, кроме этой
 * надписи, и оставлял вопрос «чем группа отличается от круга». Теперь название приходит с сервера
 * посчитанным из СОСТАВА кругов: только личные — «Семья», только бизнес — «Компания», вперемешку —
 * нейтральное. Хранить и настраивать больше нечего.
 *
 * Module-level ref → выставляется один раз из пробы доступа в App.vue, читается везде.
 */
const groupLabel = ref<FamilyGroupLabel>('FAMILY');

export function setFamilyGroupLabel(l: FamilyGroupLabel | null | undefined): void {
  if (l) groupLabel.value = l;
}

export function useFamilyLabels() {
  const { t } = useI18n();
  // Заголовок экрана («Семейный офис» / «Компания» / «Мой круг») и подпись вкладки внизу.
  const title = computed(() => t(`family.label.${groupLabel.value}`));
  const navLabel = computed(() => t(`family.tab.${groupLabel.value}`));
  return { title, navLabel, groupLabel };
}
